<template>
  <b-modal
    centered
    size="xl"
    ref="incomponent-tutorial-modal"
    hide-footer
    hide-header
  >
    <b-container>
      <b-row>
        <b-col class="text-center">
          <h3 style="display: inline-block">Tutorial</h3>
          <v-icon scale="1.5"
            class="close-button"
            name="times"
            @click="close()" />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="1">
          <b-button
            style="height: 100% !important;"
            variant="unknown"
            :disabled="index === 0"
            class="no-outline border-none text-dark"
            @click="goBack()"
          >
            <v-icon name="step-backward" />
          </b-button>
        </b-col>
        <b-col cols="10">
          <b-overlay :show="loading" rounded="sm">
            <b-img fluid :src="showingImage" @load="loading = false"/>
          </b-overlay>
        </b-col>
        <b-col cols="1">
          <b-button
            style="height: 100% !important;"
            variant="unknown"
            :disabled="index === finalImages.length-1"
            class="no-outline border-none text-dark"
            @click="goAhead()"
          >
            <v-icon name="step-forward" />
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center font-weight-bold text-primary" style="white-space: pre-wrap;">
          {{ suggestions.length>index? suggestions[index].text : 'No hay más sugerencias'}}
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center text-primary">
          <b-form-group>
            <b-form-radio-group id="radio-group-2" v-model="index" name="pages">
              <b-form-radio class="text-primary" v-for="(image, i) in finalImages" :key="image" :value="i" />
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>
<script>
import suggestionsService from "../../../services/suggestionsService";

export default {
  components: {
  },
  data () {
    return {
      images: [
        require('../../../assets/img/tutorial/Tutorial sin texto Redpie4 (1)-7.jpg'),
        require('../../../assets/img/tutorial/Tutorial sin texto Redpie4 (1)-8.jpg'),
        require('../../../assets/img/tutorial/Tutorial sin texto Redpie4 (1)-9.jpg'),
        require('../../../assets/img/tutorial/Tutorial sin texto Redpie4 (1)-10.jpg'),
        require('../../../assets/img/tutorial/Tutorial sin texto Redpie4 (1)-11.jpg'),
        require('../../../assets/img/tutorial/Tutorial sin texto Redpie4 (1)-12.jpg'),
        require('../../../assets/img/tutorial/Tutorial sin texto Redpie4 (1)-20.jpg'),
        require('../../../assets/img/tutorial/Tutorial sin texto Redpie4 (1)-24.jpg'),
      ],
      obtainedImages: [],
      index: 0,
      suggestions: [],
      showingImage: "",
      loading: false,
    }
  },
  created() {
    this.getRedpieTutorialIndications();
    this.getRedpieTutorialSlides();
  },
  computed: {
    finalImages: function() {
      if (this.obtainedImages.length > 0) {
        return this.obtainedImages
      }
      else {
        return this.images;
      }
    }
  },
  mounted() {
  },
  methods: {
    open() {
      this.index = 0;
      this.loading = true;
      this.$nextTick(() => {
        this.showingImage = this.finalImages[this.index];
      })
      this.$refs["incomponent-tutorial-modal"].show();
    },
    close() {
      this.$refs["incomponent-tutorial-modal"].hide();
    },
    getRedpieTutorialIndications: function () {
      suggestionsService.getRedpieTutorialIndications().then(
        data => {
          this.suggestions = data;
        }
      )
    },
    getRedpieTutorialSlides: function () {
      suggestionsService.getRedpieTutorialSlides().then(
        data => {
          this.obtainedImages = data.slides.map(
            (slide) => {
              if (slide.slide.startsWith('http')) {
                return slide.slide;
              }
              else {
                return process.env.VUE_APP_BASE_URL+slide.slide;
              }
            }
          );
        }
      )
    },
    goAhead() {
      this.loading = true;
      this.$nextTick(() => {
        this.index = (this.index < this.finalImages.length - 1) ? this.index + 1 : this.finalImages.length -1
        this.showingImage = this.finalImages[this.index];
      })
    },
    goBack() {
      this.loading = true;
      this.$nextTick(() => {
        this.index = (this.index > 0) ? this.index - 1 : 0
        this.showingImage = this.finalImages[this.index];
      })
    }
  }
}
</script>
<style lang="scss">
.row {
  padding-bottom: 5px;

  .custom-col {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 0px !important;
  }
}
.close-button {
  cursor: pointer !important;
  display: inline-block;
  position: absolute;
  right: 5px;
}
</style>
